export class ListKeyManager<T> {
  private _activeItem: T | null = null;
  private _activeItemIndex = -1;

  constructor(public _items: T[]) {
    if (this._activeItem) {
      const itemArray = this._items;
      const newIndex = itemArray.indexOf(this._activeItem);

      if (newIndex > -1 && newIndex !== this._activeItemIndex) {
        this._activeItemIndex = newIndex;
      }
    }
  }

  public handleKeyDown(event: KeyboardEvent): void{
    const { key } = event;

    switch (key) {
      case "Tab": console.log('Tab'); break;
      case "Escape": console.log('ESC') ; break;
      case "ArrowDown": console.log('ESC') ; break;
    }
  }
}
